import * as React from 'react';

export const OverPaidText = () => (
  <div
    data-testid="PostRegEditsReview--negative-balace-text"
    className="sui-caption"
  >
    This change will result in an overpayment. A refund will <b>not</b> be
    automatically processed. After confirming the changes, you will be presented
    a link to the order details, where you can manually process the refund.
  </div>
);
